<div class="Customers ui-g">
  <div class="ui-g-12">
    <h1 class="step-title">{{ 'report.reportUsers' | translate }}</h1>
  </div>
  <div class="ui-g-12 divider">
    <hr>
  </div>
  
  <div class="ui-g-12 ui-fluid">
  
    <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
      <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex" [readonly]="false"></p-steps>
    </div>
  
    <div class="overview-container ui-g-nopad">
      <app-report-company-app [hidden]="this.activeTabIndex != 0" (infoReport)="infoReportDescription($event)" (showInfo)="showInfoPopUp($event)"></app-report-company-app>
  
      <app-report-user-company-app [hidden]="this.activeTabIndex != 1" (infoReport)="infoReportDescription($event)" (showInfo)="showInfoPopUp($event)"></app-report-user-company-app>
    
      <app-report-user-roles [hidden]="this.activeTabIndex != 2" (infoReport)="infoReportDescription($event)" (showInfo)="showInfoPopUp($event)"></app-report-user-roles>
     
      <app-report-roles-permission [hidden]="this.activeTabIndex != 3" (infoReport)="infoReportDescription($event)" (showInfo)="showInfoPopUp($event)"></app-report-roles-permission>
    </div>
   
  
  </div>
</div>

<!-- Pop Up Info Report -->
<p-dialog
  *ngIf="showInfo"
  [(visible)]="showInfo"
  [modal]="true"
  header="{{ 'report.info' | translate }}"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  {{ infoReport }}
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user.component.html